<template>
    <div>
        <div class="card rounded-0 mb-3" v-if="hideReferenceLocation == false">
            <h3 class="card-header">
                Reference Design Download Details
            </h3>
            <div class="card-body">
                <div class="form-group">
                    <div class="btn-dark my-1" v-show="!this.validFileLocation">Local Folder location is not valid</div>
                    <div class="row">
                        <label for="downloadLocation" class="col-4">
                            Local Folder
                            <i class="fa fa-info-circle ul-tooltip" data-toggle="tooltip" data-placement="top" title="The Reference Design Download Folder Location specifies where to place any downloaded Reference Designs"></i>
                        </label>
                        <div class="col-8">
                            <input class="form-control rounded-0" type="text" id="downloadLocation" name="downloadLocation" v-model="fusionProfile.downloadLocation">
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer text-right">
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import _debounce from 'lodash/debounce'

    export default {
        name: 'Profile',
        data() {
            return {
                fusionProfileChanged: false,
                fusionProfile: {
                    downloadLocation: null
                }
            }
        },
        props: {
            hideReferenceLocation: {
                type: Boolean,
                default: () => {
                    return false;
                }
            }
        },
        computed: {
            ...mapState({
                profile: state => state.profile
            }),
            validFileLocation() {
                const regex = new RegExp('^[a-zA-Z]:\\\\([a-zA-Z0-9.\\-*.+]+([ ][a-zA-Z0-9.\\-*.+]+)*\\\\)*([a-zA-Z0-9.\\-*.+]+([ ][a-zA-Z0-9.\\-*.+]+)*)*$|^([a-zA-Z]:)?/([a-zA-Z0-9.\\-*.+]+([ ][a-zA-Z0-9.\\-*.+]+)*/)*([a-zA-Z0-9.\\-*.+]+([ ][a-zA-Z0-9.\\-*.+]+)*)*$');
                return regex.test(this.fusionProfile.downloadLocation);
            }
        },
        methods: {
            ResetProfile: function () {
                if (this.fusionProfileChanged) {
                    this.fusionProfile = JSON.parse(JSON.stringify(this.profile));
                    this.fusionProfileChanged = false;
                }
            },
            SaveProfile: function () {
                if (this.fusionProfileChanged) {
                    this.fusionProfileChanged = false;
                    this.$store.dispatch('setUserProfile', this.fusionProfile);
                }
            }
        },
        mounted: async function () {
            await this.$router.isReady();
            await this.$store.dispatch('refreshProfile');
        },
        watch: {
            'profile': {
                handler: function (val) {
                    if (val && typeof (val) != undefined)
                        this.fusionProfile = JSON.parse(JSON.stringify(val));
                    else
                        this.fusionProfile.targetProfiles = { downloadLocation: "" };
                },
                deep: true
            },
            'fusionProfile.downloadLocation': {
                handler: _debounce(function () {
                    if (this.validFileLocation) {
                        this.fusionProfileChanged = true;
                        this.SaveProfile();
                    }
                }, 600)
            }
        }
    }
</script>

<style scoped>
    .btn.disabled, .btn[disabled], fieldset[disabled] .btn {
        cursor: not-allowed;
    }

    .btn-dark.disabled, .btn-dark:disabled, .btn-dark[disabled] {
        color: white;
        background-color: var(--ul-red);
        border-color: var(--ul-red);
        opacity: .65;
    }

    div.d-flex.flex-row .flex-1 {
        max-width: 625px;
    }
</style>